module.exports = __webpack_public_path__ + "static/media/feedback.ae972dc0.svg";